import React from 'react';
import Footer from "../footer/footer"
const stats = () =>{
  return (
    <div>
      <h3>Stats</h3>
      <Footer/>
    </div>
  );
}
export default stats;